import { useQueryClient } from '@tanstack/react-query'
import { Flex, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { prefetchPathIntent } from '../lib/performance/prefetch'

interface TabItem {
  title: string
  path?: string
  tab: string
  onSelectTab?: (tab: string, path?: string) => void
}

const disabledTabs = [ 'Integration', 'Analytics']

const TabItemComponent: React.FC<TabItem & { selected: boolean }> = ({ title, path, tab, selected, onSelectTab }) => {
  const queryClient = useQueryClient()
  const isDisabled = disabledTabs.includes(title)

  const handleNavigation = (path: string, tab: string) => {
    onSelectTab?.(tab, path)
  }

  return (
    <Flex
      align="center"
      px="16px"
      py="7px"
      borderRadius="20px"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      bg={selected ? 'white' : 'transparent'}
      color={selected ? 'primary.100' : 'solid.400'}
      fontWeight={selected ? '700' : '500'}
      boxShadow={
        selected
          ? '0px 1px 3px rgba(93, 94, 203, 0.12), 0px 2px 8px rgba(93, 94, 203, 0.08)'
          : 'none'
      }
      transition="all 0.2s ease-out"
      sx={{
        '@media (hover: hover)': {
          '&:hover': isDisabled
            ? {}
            : selected
              ? {
                  transform: 'translateY(-1px)',
                  boxShadow: '0px 2px 6px rgba(93, 94, 203, 0.16), 0px 4px 12px rgba(93, 94, 203, 0.10)',
                }
              : {
                  bg: 'white',
                  color: 'solid.600',
                  transform: 'translateY(-1px)',
                  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08), 0px 4px 12px rgba(0, 0, 0, 0.04)',
                },
        },
      }}
      onMouseEnter={() => path && prefetchPathIntent(path, queryClient)}
      onFocus={() => path && prefetchPathIntent(path, queryClient)}
      onClick={() => !isDisabled && handleNavigation(path || '', tab)}
      opacity={isDisabled ? 0.45 : 1}
      position="relative"
    >
      <Text textStyle="l-s" whiteSpace="nowrap" lineHeight="20px">
        {title}
      </Text>
    </Flex>
  )
}

export default TabItemComponent
